import { render } from "./addPreMoneyModel.vue?vue&type=template&id=0f3c1fc6"
import script from "./addPreMoneyModel.vue?vue&type=script&lang=js"
export * from "./addPreMoneyModel.vue?vue&type=script&lang=js"

import "./addPreMoneyModel.vue?vue&type=style&index=0&id=0f3c1fc6&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__